module.exports = __webpack_public_path__ + "img/symbol_3.b0e3e19e.png";